import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/error-icon.png'
import _imports_1 from '@assets/images/star.png'
import _imports_2 from '@assets/images/standard.png'
import _imports_3 from '@assets/images/backIcon.png'


const _hoisted_1 = { class: "grad-container" }
const _hoisted_2 = { class: "grad-inner" }
const _hoisted_3 = { class: "grad-body" }
const _hoisted_4 = { class: "grad-time-box" }
const _hoisted_5 = { class: "time-box-container info-btn flex-row" }
const _hoisted_6 = { class: "inner-box" }
const _hoisted_7 = { class: "time-text font-DIN" }
const _hoisted_8 = { class: "warn-box" }
const _hoisted_9 = { class: "score-container" }
const _hoisted_10 = { class: "lf-box" }
const _hoisted_11 = { class: "lft-tp-box info-btn flex-row" }
const _hoisted_12 = { class: "vl-txt font-DIN" }
const _hoisted_13 = { class: "lft-bt-box info-btn flex-row" }
const _hoisted_14 = { class: "rgt-box info-btn" }
const _hoisted_15 = { class: "grad-base-info" }
const _hoisted_16 = {
  class: "grad-btn-container flex-row",
  style: {"justify-content":"flex-end"}
}
const _hoisted_17 = { class: "btn-box" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    gradTotalTime: {
        type: String,
        default: '00:00'
    },
    crash:{
        type: Boolean,
        default: false
    },
    gradScore:{
        type: [Number, String],
        default: 0
    },
    evaluate:{
        type: Boolean,
        default: false
    },
    showDownload:{
        type: Boolean,
        default: false
    },
    loading:{
        type: Boolean,
        default: false
    },
    isShowRestart:{
        type: Boolean,
        default: true
    }
},
  emits: ['onBack', 'onRestart', 'onDownload'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit


return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("span", null, "成绩")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_vkm_svg, {
                "icon-name": "clock",
                class: "icon"
              }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(props.gradTotalTime), 1)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, _cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1),
            _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分", -1)
          ]), 512), [
            [_vShow, props.crash]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "img-box flex-row" }, [
                _createElementVNode("img", { src: _imports_1 }),
                _createElementVNode("span", null, "得分")
              ], -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(props.gradScore), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "img-box flex-row" }, [
                _createElementVNode("img", { src: _imports_2 }),
                _createElementVNode("span", null, "评价")
              ], -1)),
              _createElementVNode("span", {
                class: _normalizeClass(props.evaluate?'vl-txt green':'vl-txt red')
              }, _toDisplayString(props.evaluate?'合格':'不合格'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _renderSlot(_ctx.$slots, "gradCanvas")
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _renderSlot(_ctx.$slots, "flyInfo")
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (props.showDownload)
            ? (_openBlock(), _createBlock(_component_vkn_button, {
                key: 0,
                label: "下载报告",
                type: "tertiary",
                loading: props.loading,
                size: "medium",
                onClick: _cache[0] || (_cache[0] = ()=>{emits('onDownload')})
              }, {
                icon: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "iconfont-line vk_xz_line" }, null, -1)
                ])),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (props.isShowRestart)
            ? (_openBlock(), _createBlock(_component_vkn_button, {
                key: 1,
                label: "重新开始",
                type: "tertiary",
                size: "medium",
                onClick: _cache[1] || (_cache[1] = ()=>{emits('onRestart', false)})
              }, {
                icon: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_vkn_button, {
            label: "返回",
            type: "tertiary",
            size: "medium",
            onClick: _cache[2] || (_cache[2] = ()=>{emits('onBack')})
          }, {
            icon: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("img", { src: _imports_3 }, null, -1)
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})